import React, {useEffect} from 'react';
import {useAppDispatch, useAppSelector} from "common/hook";
import {FormGroupSettings} from "../../form/FormGroupSettings";
import {FormNote} from "../../form/Form-note";
import {FormEditProfile} from "../../form/Form-edit-profile";
import {FormChangePassword} from "../../form/Form-change-password";
import {FormProblemsClass} from "../../form/Form-problems-class";
import {FormAddCut} from "../../form/Form-add-cut";
import {FormLanguageLevel} from "../../form/Form-language-level";
import {FormAddTest} from "../../form/Form-add-test";

import {FormFeedback} from "../../header/navigate/form/FormFeedback";
import {
    isFoolPopupServiceAC,
    setAddCutAC,
    setChangePasswordAC,
    setEditAC,
    setEditProfileAC,
    setFormAddTestAC,
    setFormFeedbackAC,
    setFormReviewAC,
    setLanguageLevelAC, setPopupsOfflineAC,
    setProblemsClassAC,
    setSettingPopupsAC
} from "app/popups-reducer";
import {FormReview} from "../../form/Form-review";
import {PopupsOffline} from "components/form/PopupsOffline";


export const Popups = () => {
    const isFoolPopupService = useAppSelector((state) => state.popups.isFoolPopupService);
    const isGroupSetting = useAppSelector((state) => state.popups.isGroupSetting);
    const isEdit = useAppSelector((state) => state.popups.isEdit);
    const isEditProfile = useAppSelector((state) => state.popups.isEditProfile);
    const isChangePassword = useAppSelector((state) => state.popups.isChangePassword);
    const isProblemsClass = useAppSelector((state) => state.popups.isProblemsClass);
    const isAddCut = useAppSelector((state) => state.popups.isAddCut);
    const isLanguageLevel = useAppSelector((state) => state.popups.isLanguageLevel);
    const isFormAddTest = useAppSelector((state) => state.popups.isFormAddTest);
    const isFormFeedback = useAppSelector((state) => state.popups.isFormFeedback);
    const isFormReview = useAppSelector((state) => state.popups.isFormReview);
    const isPopupsOffline = useAppSelector((state) => state.popups.isPopupsOffline);
    const dispatch = useAppDispatch();


    useEffect(() => {
        if (isFoolPopupService) {
            dispatch(setSettingPopupsAC(false));
            dispatch(setEditAC(false));
            dispatch(setEditProfileAC(false));
            dispatch(setChangePasswordAC(false));
            dispatch(setProblemsClassAC(false));
            dispatch(setAddCutAC(false));
            dispatch(setLanguageLevelAC(false));
            dispatch(setFormAddTestAC(false));
            dispatch(setFormFeedbackAC(false));
            dispatch(setFormReviewAC(false));
        }
    }, [isFoolPopupService]);


    const onClickClosePopupsHandler = () => {
        dispatch(setSettingPopupsAC(false));
        dispatch(setEditAC(false));
        dispatch(setEditProfileAC(false));
        dispatch(setChangePasswordAC(false));
        dispatch(setProblemsClassAC(false));
        dispatch(setAddCutAC(false));
        dispatch(setLanguageLevelAC(false));
        dispatch(setFormAddTestAC(false));
        dispatch(setFormFeedbackAC(false));
        dispatch(setFormReviewAC(false));
    };



    useEffect(() => {
        if (
            isFoolPopupService ||
            isGroupSetting ||
            isEdit ||
            isEditProfile ||
            isChangePassword ||
            isProblemsClass ||
            isAddCut ||
            isFormAddTest ||
            isLanguageLevel ||
            isFormFeedback ||
            isFormReview ||
            isPopupsOffline
        ) {
            document.documentElement.classList.add('opened-popup');
        } else {
            document.documentElement.classList.remove('opened-popup');
        }
    }, [isFoolPopupService,isGroupSetting, isEdit, isEditProfile, isChangePassword, isProblemsClass, isAddCut,isFormAddTest,isPopupsOffline, isLanguageLevel,isFormFeedback,isFormReview]);

    return (
        <div id="app-popup-box" onClick={onClickClosePopupsHandler} >
            <div className="container">
                <div className={`popup form-popup ${isGroupSetting ? 'visible' : ''}`} id="group-settings-form"
                     onClick={(e) => e.stopPropagation()}>
                    {isGroupSetting && <FormGroupSettings/>}
                </div>
                <div className={`popup form-popup ${isEdit ? 'visible' : ''}`} id="form-note"
                     onClick={(e) => e.stopPropagation()}>
                    {isEdit && <FormNote/>}
                </div>
                <div className={`popup form-popup ${isEditProfile ? 'visible' : ''}`} id="edit-profile-popup"
                     onClick={(e) => e.stopPropagation()}>
                    {isEditProfile && <FormEditProfile/>}
                </div>
                <div className={`popup form-popup ${isChangePassword ? 'visible' : ''}`} id="change-password-popup"
                     onClick={(e) => e.stopPropagation()}>
                    {isChangePassword && <FormChangePassword/>}
                </div>
                <div className={`popup form-popup ${isProblemsClass ? 'visible' : ''}`} id="problems-popup"
                     onClick={(e) => e.stopPropagation()}>
                    {isProblemsClass && <FormProblemsClass/>}
                </div>
                <div className={`popup form-popup ${isAddCut ? 'visible' : ''}`} id="add-cut-popup"
                     onClick={(e) => e.stopPropagation()}>
                    {isAddCut && <FormAddCut/>}
                </div>
                <div className={`popup form-popup ${isLanguageLevel ? 'visible' : ''}`} id="cefr-level-popup"
                     onClick={(e) => e.stopPropagation()}>
                    {isLanguageLevel && <FormLanguageLevel/>}
                </div>
                <div className={`popup form-popup ${isFormAddTest ? 'visible' : ''}`} id="add-test-popup"
                     onClick={(e) => e.stopPropagation()}>
                    {isFormAddTest && <FormAddTest/>}
                </div>
                <div className={`popup form-popup ${isFormFeedback ? 'visible' : ''}`} id="student-feedback-popup"
                     onClick={(e) => e.stopPropagation()}>
                    {isFormFeedback && <FormFeedback/>}
                </div>
                <>
                    {isFormReview && <FormReview/>}
                </>
                <div className={`popup form-popup ${isPopupsOffline ? 'visible' : ''}`} id="offline-popup"
                     onClick={(e) => e.stopPropagation()}>
                    {isPopupsOffline && <PopupsOffline/>}
                </div>
            </div>
        </div>
    );
};



